(function(d,w) {
  var container = document.querySelector('.header-links');
  if (!container) return;

  var megaMenus = container.querySelectorAll('[data-has-mega-menu]');
  if (megaMenus.length === 0) return;

  let usingTouchEvents;
  let previoustMegaMenu = null;
  let currentMegaMenu = null;
  let allowMainLinkTouch = false;
  let hasLoadedItems;

  let timeoutId;
  let delay = 500;
  
  // Async the items for the mega menus
  const addItems = async () => {
    var fetchItems = await fetch (w.Shopify.routes.root + "?section_id=async-mega-menu-items")
      .then(res => res.text())
      .then(text => {
        var markup = new DOMParser().parseFromString(text, "text/html");
        var content = markup.querySelector('.async-mega-menu-items');

        return content;
      });;

    if (!fetchItems) return;
    
    d.querySelector('.header-links').querySelectorAll('[data-mega-menu-items]').forEach(div => {
      var handle = div.dataset.megaMenuItems;
      if (!handle) return;

      fetchItems.querySelectorAll('[data-async-mega-menu-items]').forEach(items => {
        if (items.dataset.asyncMegaMenuItems === handle) {
          div.innerHTML = items.innerHTML;
        }
      });
    })
  }

  var delayedMegaMenuOpen;
  var delayedMegaMenuClose;
  var activeMegaMenu;
  var hasUsedTouch;
  var preventMainLink = true;
  var getAsyncItems = true;
  var hasLeftBeforeDelay = false;

  const openingMegaMenu = (e) => {
    var trigger = e.detail.trigger;
    if (!activeMegaMenu) activeMegaMenu = trigger;
    
    var triggerIsActive = trigger === activeMegaMenu;

    if (getAsyncItems) {
      addItems();
      getAsyncItems = false;
    }

    if (delayedMegaMenuOpen) {
      clearTimeout(delayedMegaMenuOpen);
    }
    
    if (delayedMegaMenuClose) {
      clearTimeout(delayedMegaMenuClose);

      if (!triggerIsActive) {
        activeMegaMenu.classList.remove('has-active-menu');
        trigger.classList.add('has-active-menu');
        
        activeMegaMenu = trigger;
        
        return;
      }
    }

    delayedMegaMenuOpen = setTimeout(() => {
      if (!hasLeftBeforeDelay) {
        activeMegaMenu.classList.add('has-active-menu');
      }
    }, delay);
    
    hasLeftBeforeDelay = false;
  };
  
  const closingMegaMenu = () => {
    delayedMegaMenuClose = setTimeout(() => {
      activeMegaMenu.classList.remove('has-active-menu');
      
      activeMegaMenu = false;
    }, delay);
  };
  
  const openingMegaMenuTouch = (e) => {
    var trigger = e.detail.trigger;
    
    if (!hasUsedTouch) hasUsedTouch = true;
    
    if (getAsyncItems) {
      addItems();
      getAsyncItems = false;
    }

    var closestTrigger = e.target.classList.contains('has-active-menu') || e.target.closest('.has-active-menu');

    if (!preventMainLink && trigger !== activeMegaMenu) {
      preventMainLink = true;
    }
    
    if (trigger === activeMegaMenu) {
      if (preventMainLink) {
        preventMainLink = false;
        return;
      }
    }

    if (activeMegaMenu && trigger !== activeMegaMenu) {
      activeMegaMenu.classList.remove('has-active-menu');
    }
    
    trigger.classList.add('has-active-menu');
    
    activeMegaMenu = trigger;
  };

  const openingMegaMenuClick = (e) => {
    if (preventMainLink && hasUsedTouch) {
      e.preventDefault();
    }
  }

  const leftBeforeDelay = (e) => {
    if (delayedMegaMenuOpen) {
      hasLeftBeforeDelay = true;
    }
  }

  // Event bus
  container.addEventListener('mega-menu:enter', openingMegaMenu);
  container.addEventListener('mega-menu:leave', closingMegaMenu);
  container.addEventListener('mega-menu:left-before-delay', leftBeforeDelay);
  container.addEventListener('mega-menu:touch', openingMegaMenuTouch);
  container.addEventListener('mega-menu:click', openingMegaMenuClick);

  // Used to send mega menu events
  const megaMenuEvent = (eventType, trigger) => {
    container.dispatchEvent(new CustomEvent ("mega-menu:" + eventType, {
      bubbles: true,
      detail: { 
        trigger: trigger,
      }
    }));
  }
  
  // Bind event types to mega menu links
  megaMenus.forEach(menu => {
    menu.addEventListener("mouseenter", () => megaMenuEvent('enter', menu));
    menu.addEventListener("mouseleave", () => megaMenuEvent('leave', menu));
    menu.addEventListener("mouseleave", () => megaMenuEvent('left-before-delay', menu));
    menu.addEventListener("touchstart", () => megaMenuEvent('touch', menu), {
      capture: true, 
      passive: true,
    });
    menu.addEventListener("click", openingMegaMenuClick);
  });

  // Close mega menu on small desktop/tablet screens, when clicking outside a mega menu
  document.body.addEventListener('click', e => {
    var targetIsMegaMenu = e.target.dataset.hasMegaMenu || e.target.closest('[data-has-mega-menu]');

    if (targetIsMegaMenu === activeMegaMenu) return;
    
    if (hasUsedTouch) {
      if (!targetIsMegaMenu && activeMegaMenu) {
        activeMegaMenu.classList.remove('has-active-menu');
        activeMegaMenu = false;
        preventMainLink = true;
      }
    }
  });
})(document, window);